export function makeEdgeKey(sourceNodeId, targetNodeId, sourceHandleId) {
    return sourceHandleId ? `${sourceNodeId}\u2192${targetNodeId}#${sourceHandleId}` : `${sourceNodeId}\u2192${targetNodeId}`;
}

//# sourceMappingURL=types.js.map